import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { WorkScheduleComponent } from '../work-schedule.component';
import { ResizableDirective } from './work-schedule.resizable.directive';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FormsModule } from '@angular/forms';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { BalloonTooltipDirective } from '../../../directives/balloon.tooltip.directive';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTooltipModule } from '@angular/material';

@NgModule({
  declarations: [WorkScheduleComponent, ResizableDirective, BalloonTooltipDirective],
  imports: [
    CommonModule,
    DragDropModule,
    PerfectScrollbarModule,
    DateInputsModule,
    FormsModule,
    DropDownsModule,
    BrowserAnimationsModule,
    MatTooltipModule
  ],
  exports: [WorkScheduleComponent, ResizableDirective]
})
export class WorkScheduleModule { }
